<template>
  <div class="c-media-box" @click="toArticlePage">
    <img class="media__img" :src="data.imgPath" />
    <div class="media__type">
      <div class="media__type__box">
        <span class="media__type__box__text">{{ data.type }}</span>
      </div>
    </div>
    <p class="media__title">{{ data.title }}</p>
    <p class="media__desc">{{ data.desc }}</p>
    <divide dashed />

    <div class="media__btn-date">
      <p class="media__btn-date__date">{{ `${formatPublish.y}年${formatPublish.m}月${formatPublish.d}日` }}</p>
      <div class="media__btn-date__btn">
        <pr-button arrow width="136" >瞭解更多</pr-button>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';
import Divide from '@/components/Global/Divide.vue';

export default defineComponent({
  name: 'NewBox',
  components: {
    PrButton,
    Divide,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();

    const formatPublish = computed(() => {
      const date = dayjs(props.data.published).format('YYYY-MM-DD');
      const [y, m, d] = date.split('-');
      return {
        y, m, d,
      };
    });

    const toArticlePage = () => {
      router.push({
        name: 'announcement',
        query: {
          id: props.data.id,
        },
      });
    };

    return {
      formatPublish,
      toArticlePage,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.c-media-box {
  cursor: pointer;
  width: 100%;
  display: flex;
flex-direction: column;
}

.media {
  &__img {
    width: 100%;
    // height: 200px;
    border-radius: 20px;
  }

  &__type {
    &__box {

      padding: 0 14px;
      display: inline-block;
      margin-top: 28px;
      background-color: rgba($c-main-yellow, 0.5);
      border-radius: 10px;

      &__text {
        @include font-normal();
      }
    }
  }

  &__title {
    white-space: normal;
    @include font-style($c-main-brown, 20, 400, 1px, 28px);
    margin-top: 12px;
    height: 84px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__desc {
    margin-top: 12px;
    @include font-normal();
    @include font-style($c-main-brown, 16, 400, 1.2px, 28px);

    white-space: normal;

    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  &__btn {

    margin-top: 40px;
  }
}

.media {
  &__btn-date {
    @include flex(flex-start, flex-start, column);

    &__date {
      margin-bottom: 30px;

      @include font-normal();
    }

    &__btn {
      width: 100%;
    }
  }
}

@media screen and (min-width: $pc) {
  .media {
    &__btn-date {
      @include flex(space-between, center, row);

      &__date {
        margin-bottom: 0px;
        order: 2;
      }

      &__btn {

        order: 1;
      }
    }
  }
}
</style>
